import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { StageAdmin } from '@/types';
import { StageEditor } from './StageEditor';

export function StagesTabs({
  eventSlug,
  stages,
}: {
  eventSlug: string;
  stages: StageAdmin[];
}) {
  const [activeId, setActiveId] = useState<string>(stages[0]?.id ?? '');
  const active = stages.find((s) => s.id === activeId) ?? stages[0];

  if (!active) return null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap gap-1 border-b">
        {stages.map((s) => {
          const isActive = s.id === active.id;
          const presenting = s.projects.find((p) => p.isCurrentlyPresenting);
          return (
            <Button
              key={s.id}
              variant="ghost"
              onClick={() => setActiveId(s.id)}
              className={cn(
                'rounded-none border-primary border-b-2 px-4',
                isActive
                  ? 'border-primary text-foreground'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )}
            >
              {s.name}
              <span className="ml-2 font-mono text-muted-foreground text-xs">
                /{s.slug}
              </span>
              {s.isFinal && (
                <span className="ml-2 bg-primary px-1 font-mono text-[10px] text-primary-foreground uppercase">
                  final
                </span>
              )}
              {presenting && (
                <span className="ml-2 inline-flex items-center gap-1 font-mono text-[10px] text-primary uppercase">
                  <span className="size-1.5 bg-primary" /> live
                </span>
              )}
            </Button>
          );
        })}
      </div>

      <div>
        <h2 className="mb-1 font-bold text-xl">{active.name}</h2>
        <StageEditor
          key={active.id}
          eventSlug={eventSlug}
          stage={active}
          otherStages={stages
            .filter((s) => s.id !== active.id)
            .map((s) => ({ id: s.id, name: s.name, slug: s.slug }))}
        />
      </div>
    </div>
  );
}
